import { getSupportUnreadSummary } from '@/api/backend';

const defaultState = {
  unreadCount: 0,
};

const mutations = {
  setUnreadCount(state, unreadCount) {
    state.unreadCount = Math.max(0, Number(unreadCount) || 0);
  },
};

const actions = {
  async refresh({ commit, rootState }) {
    if (rootState.auth?.role !== 'admin') {
      commit('setUnreadCount', 0);
      return;
    }
    try {
      const response = await getSupportUnreadSummary();
      if (response.ok) {
        commit('setUnreadCount', response.data?.unreadCount ?? 0);
      }
    } catch {
      // keep last known count
    }
  },
};

export default {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
};
